import { sessionState } from 'src/app/core/services/signal-state.storage';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-gdo-connected-garage-features-webview',
    templateUrl: './gdo-connected-garage-features-webview.component.html',
    styleUrls: ['./gdo-connected-garage-features-webview.component.scss'],
    standalone: false
})
export class GdoConnectedGarageFeaturesWebviewComponent implements OnInit {
  hideCancelButton: Boolean = true;
  isAcura:boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<GdoConnectedGarageFeaturesWebviewComponent>,
    private appService:AppService
  ) {}

  ngOnInit(): void {
    this.hideCancelButton = false;
    this.setIsAcuraLocally();
  }
  setIsAcuraLocally() {
    let vehicleData = sessionState.getItem("vehicleMake");
    if (vehicleData) {
      vehicleData = vehicleData.toLowerCase();
      if (vehicleData == 'acura') {
        this.isAcura = true;
      }
    }
  }
  onCancel(): void {
    this.dialogRef.close();
  }

  onAccept(): void {
    this.dialogRef.close();
  }

  onClickClose() {
    this.dialogRef.close();
  }
}
